import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import  *  as moment from "moment"
import { PaymentResponseStatus } from "../models/payment-response.enum";
import { PaymentReceiptsService } from "./payment-receipt.service";
import { Payment } from "../models/payment";
import { PaymentResponseModel } from "../models/payment-response.model";
import { SharedModalInfoComponent } from "../../../shared/modal-info/modal-info.component";
import { PaymentAntifraudeModel } from "../models/payment-antifraude.model";
import { ModalAntifraudWarningComponent } from "../../../shared/modal-antifraud-warning/modal-antifraud-warning.component";

@Injectable()
export class PaymentResponseHandlerService {
	private situation: PaymentResponseStatus;
	private antiFraudeData = new PaymentAntifraudeModel();

    constructor(
        private dialog: MatDialog,
        private router: Router,
        private paymentReceiptsService: PaymentReceiptsService,
    ) { }

    processResult(result: PaymentResponseModel, message: string, payment: Payment): boolean {
        switch (result.situacao) {
					case PaymentResponseStatus.AGUARDANDO_AUTORIZACAO:
					case PaymentResponseStatus.PENDENTE_DEMAIS_APROVACOES:
                if(payment.codeBarCip){
                    this.paymentReceiptsService.setCipReceiptModel(false, payment, this.isToday(payment, result), result)
                    return true;
                }

                this.paymentReceiptsService.setAgreementReceiptModel(false, payment, this.isToday(payment, result), result);
                return true;
            case PaymentResponseStatus.AUTORIZADA_AGUARDANDO_EFETIVACAO:
                if(payment.codeBarCip){
                    this.paymentReceiptsService.setCipReceiptModel(true, payment, false, result)
                    return true;
                }

                this.paymentReceiptsService.setAgreementReceiptModel(true, payment, false, result);
						return true;
						case PaymentResponseStatus.AUTORIZADA_PELO_ANTI_FRAUDE:
						case PaymentResponseStatus.TIME_OUT_DO_ANTI_FRAUDE:
            case PaymentResponseStatus.TRANSFERENCIA_REALIZADA:
                if(payment.codeBarCip){
                    this.paymentReceiptsService.setCipReceiptModel(true, payment, true, result)
                    return true;
                }

                this.paymentReceiptsService.setAgreementReceiptModel(true, payment, true, result);
                return true;
            case PaymentResponseStatus.AGUARDANDO_CONFIRMACAO_IF_DESTINO:
                this.openModal(
                'Estamos processando essa transação',
                'Essa transação esta demorando um pouco mais que o normal',
                'Assim que ela for concluída, ele estará disponível no Extrato. Caso contrário, consulte o item no menu Transações',
                'Entendi'
                );
                return false;
				case PaymentResponseStatus.TRANSFERENCIA_REPROVADA:
				case PaymentResponseStatus.TRANSFERENCIA_EXPIRADA:
				case PaymentResponseStatus.ERRO_TRANSFERENCIA:
				case PaymentResponseStatus.REJEITADA_IF_DESTINO:
				case PaymentResponseStatus.CANCELADA_TESOURARIA:
				case PaymentResponseStatus.CANCELADA_CLIENTE:
				case PaymentResponseStatus.CANCELADA_PELO_SISTEMA_DE_OPEN_BANKING:
				case PaymentResponseStatus.CANCELADA_POR_ENCERRAMENTO_DE_CONTA:
				case PaymentResponseStatus.ENVIADA_PARA_INTEGRACAO:
				case PaymentResponseStatus.PROTOCOLO_RECEBIDO_DA_INTEGRACAO:
				case PaymentResponseStatus.REJEITADA_PELA_INTEGRACAO:
				case PaymentResponseStatus.TIME_OUT_DA_INTEGRACAO:
                this.openModal('Transação não concluída', '', message);
                return false;
				case PaymentResponseStatus.AGUARDANDO_ANALISE_ANTIFRAUDE:
					this.setAntifraudModel(payment);
					return true;
				case PaymentResponseStatus.CANCELADA_SUSPEITA_FRAUDE:
					this.dialog.open(ModalAntifraudWarningComponent, {
						data: {
							title: 'Por segurança, a sua transação está em análise.'
						}
					});
					return false;
            default:
                this.openModal(
                    'Ocorreu um erro',
                    'Por favor tente novamente mais tarde.',
										'',
										'Entendi',
                );
                return false;
        }
    }

    openModal(
    title: string,
    topText: string,
    text: string,
    btnName = 'Fechar',
    btnBackName = ''
    ) {
        const dialogRef = this.dialog.open(SharedModalInfoComponent, {
                width: '100%',
                maxWidth: '420px',
        data: {
            title: title,
            topText: topText,
            text: text,
            btnName: btnName,
            btnBackName: btnBackName,
        },
        });

        dialogRef.afterClosed().subscribe((result) => {
            this.router.navigate([''], { skipLocationChange: true });
        });
	}
	isToday(payment: Payment, result) {
		if(payment.dateType === "schedule"){
			this.paymentReceiptsService.setAgreementReceiptModel(true, payment, false, result);
				return true;
		}
		
		return moment(payment.dateLabel).format('DD/MM/YYYY') === moment(payment.date).format('DD/MM/YYYY');
	}

	setAntifraudModel(data: Payment): void {
		if (!data) {
			return;
		}

		this.antiFraudeData.name = data.assignorName ? data.assignorName : 'Pagamento de boleto';
		this.antiFraudeData.value = data.value;
		this.antiFraudeData.dateTransaction = moment(data.dateLabel).locale('pt-br').format('D MMM.');
		this.antiFraudeData.showAntifraude = true;
	}

	getAntifraudModel(): PaymentAntifraudeModel {
		return this.antiFraudeData;
	}

	clearAntifraudeModel(): void {
		this.antiFraudeData =  new PaymentAntifraudeModel();
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/payment-securities/services/payment-response-handler.ts